import React from 'react'
import {useState,useContext, useEffect} from'react'
import Card from './shared/Card'
import Button from './shared/Button'
import RatingSelector from './shared/RatingSelector'
import FeedbackContext from './context/FeedbackContext'

function FeedbackForm() {

    const {addFeedback,feedbackEdit, updateFeedback} = useContext(FeedbackContext)
    const [text, setText] = useState('')
    const [message, setMessage] = useState('')
    const [btnDisable, setBtnDisable] = useState(true)
    const [rating, setRating] = useState(10)
   
  useEffect(()=> {
   if(feedbackEdit.edit === true){
    setBtnDisable(false)
    setText(feedbackEdit.item.text)
    setRating(feedbackEdit.item.rating)
   }

  },[feedbackEdit])

    const handleTextChange = (e) => {

        if( text === ''){
            setMessage(null)
            setBtnDisable(true)
        }
        else if( text !== '' && text.trim().length <= 10){
            setMessage('Text must have atleast 10 characters')
            setBtnDisable(true)
        }
        else {
            setMessage(null)
            setBtnDisable(false)
        }
        setText(e.target.value)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if(text.trim().length > 10){
            const newFeedback ={ 
                text,
                rating,
            }
            if(feedbackEdit.edit === true){
                updateFeedback(feedbackEdit.item.id, newFeedback)
            }else{
                addFeedback(newFeedback)
            } 
            setText('')
        }
        
    }

  return (
    <Card>
        <form onSubmit={handleSubmit}>
            <h2>How would you like to rate?</h2>
            <RatingSelector select={(rating) => {setRating(rating)}}/>
            <div className='input-group'>
            <input 
                onChange = {handleTextChange}
                type="text" 
                placeholder='Write a review'
                value={text} />
            <Button type='submit' isDisabled={btnDisable}>send</Button>
            </div>
            { message && <div className='message'>{message}</div>}
            
        </form>
    </Card>
  )
}

export default FeedbackForm